module.exports = __webpack_public_path__ + "static/plausible-90b3ae06b3a9c2c82567921e9a8edd2e.png";